var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center flex-wrap ma-1"},_vm._l((_vm.gems),function(item){return _c('currency',{key:item,staticClass:"ma-1",attrs:{"name":'gem_' + item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }